import React, { useEffect } from "react";
import { Row } from "react-bootstrap";
import "./SideFilter.css";
import { useDispatch, useSelector } from "react-redux";
import {  getAllCategoryAction } from "../../redux/actions/CarAction";
const SideFilter = ({setcategoryFilter,catFilter,carType,setcarType }) => {
  const res = useSelector((state) => state.CarReduser.DeleteCar);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllCategoryAction());
  }, [res]);

  const handleChange = (val) => {
   setcategoryFilter(val)
    if (catFilter.includes(val)) {
      setcategoryFilter(catFilter.filter((item) => item !== val));
      
    } else {
      setcategoryFilter([...catFilter, val]);
    }
  };
  const handleChangeF = (val) => {
    setcarType(val)
     if (carType.includes(val)) {
       setcarType(carType.filter((item) => item !== val));
     } else {
       setcarType([...carType, val]);
     }
   };
  // const [From, setPriceFrom] = useState(0);
  // const [To, setToFrom] = useState(0);
  const AllCat = useSelector((state) => state.CarReduser.GetAllCategory);
  return (
    <div className="mt-3">
      <Row>
           <div className="d-flex flex-column mt-2">
            <div className="filter-title mt-3">النوع</div>
            <div className="d-flex mt-3">
              <input onChange={()=>handleChangeF('F')} type="checkbox" value="0" />
              <div className="filter-sub me-2 ">أول مالك</div>
            </div>
            <div className="d-flex mt-3">
              <input onChange={()=>handleChangeF('D')} type="checkbox" value="0" />
              <div className="filter-sub me-2 ">معاقين</div>
            </div>
            <div className="d-flex mt-3">
              <input onChange={()=>handleChangeF('Z')} type="checkbox" value="0" />
              <div className="filter-sub me-2 ">الزيرو</div>
            </div>
          </div>
        <div className="d-flex flex-column mt-2">
          
          <div className="filter-title">الفئة</div>
          {/* <div className="d-flex mt-3">
            <input type="checkbox" value="0" />
            <div className="filter-sub me-2 ">الكل</div>
          </div> */}
          {AllCat && AllCat.length >= 0
            ? AllCat.map((item, idx) => {
                return (
                  <div className="d-flex mt-3" key={idx}>
                    <input onChange={()=>handleChange(item.id)} type="checkbox" value={catFilter} />
                    <div className="filter-sub me-2 ">{item.name}</div>
                  </div>
                );
              })
            : null}
        </div>

        {/* <div className="d-flex flex-column mt-2">
            <div className="filter-title mt-3">الماركة</div>
            <div className="d-flex mt-3">
              <input onChange={clickBrand} type="checkbox" value="0" />
              <div className="filter-sub me-2 ">الكل</div>
            </div>
            {brand?(brand.map((item,idx)=>{return(
                     <div className="d-flex mt-3"key={idx}>
                     <input onChange={clickBrand} type="checkbox" value={item._id} />
                     <div className="filter-sub me-2 ">{item.name}</div>
                   </div>
            )})):null}
          </div> */}

        {/* <div className="filter-title my-3">السعر</div>
        <div className="d-flex">
          <p className="filter-sub my-2">من:</p>
          <input
            value={From}
            onChange={(e) => setPriceFrom(e.target.value)}
            className="m-2 text-center"
            type="number"
            style={{ width: "50px", height: "25px" }}
          />
        </div>
        <div className="d-flex">
          <p className="filter-sub my-2">الي:</p>
          <input
            value={To}
            onChange={(e) => setToFrom(e.target.value)}
            className="m-2 text-center"
            type="number"
            style={{ width: "50px", height: "25px" }}
          />
        </div> */}
      </Row>
    </div>
  );
};

export default SideFilter;
